import "@brivity/ai-components/dist/style.css";
import Typography from "@shared/v2/Typography";
import { AiComponentsProvider, AiSettings } from "@brivity/ai-components";
import { getAiToken } from "@shared/externalApi";
import { useSelector } from "react-redux";
import { useFeatureFlags, useTheme } from "../reducers/layoutReducer/selectors";

const GabbiAiSettings = () => {
  const theme = useTheme() as { name: "brivity-theme" | "place-theme" };
  const isPlaceTheme = theme.name === "place-theme";
  const aiAssistApiUrl = useSelector(
    (state: { layout: { apiUrls: { aiAssistApiUrl: string } } }) => state.layout.apiUrls.aiAssistApiUrl,
  );
  const featureFlags = useFeatureFlags() as { lenderReferral: boolean };
  return (
    <AiComponentsProvider
      theme={isPlaceTheme ? "ai-place" : "ai-brivity"}
      apiUrl={aiAssistApiUrl}
      fetchToken={() => getAiToken().then((res: { token: string }) => res.token)}
    >
      <div className="tw-mx-[32px] tw-my-[16px] tw-max-w-[1500px] tw-flex tw-flex-col tw-gap-[16px]">
        <div className="tw-bg-white tw-p-[32px] tw-rounded-[8px] tw-border-[1px] tw-border-solid tw-border-gray-10">
          {/* @ts-expect-error until v2 components are TS */}
          <Typography variant="headline1">Gabbi AI</Typography>
        </div>
        <div className="tw-bg-white tw-p-[32px] tw-rounded-[8px] tw-border-[1px] tw-border-solid tw-border-gray-10">
          <AiSettings envoy_enabled={featureFlags.lenderReferral} />
        </div>
      </div>
    </AiComponentsProvider>
  );
};

export default GabbiAiSettings;
